export default class ContentSourceMaintenanceWindowService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('contentSourceMaintenanceWindows', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('contentSourceMaintenanceWindows/'+id, params)
	}

	updateEntity(id, params){
		return this.apiService.callPut('contentSourceMaintenanceWindows/'+id, params);
	}

	createEntity(params){
		return this.apiService.callPost('contentSourceMaintenanceWindows', params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('contentSourceMaintenanceWindows/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ContentSourceMaintenaceWindowService.js